export type Device = {
  model?: string
  type?: string
  vendor?: string
  os?: string
}

export enum DeviceType {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
}

export enum DeviceOrientation {
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
}

export const isBrowser = () => !isServer()
export const isServer = () => {
  return globalThis.window === undefined
}

export const getBreakpoint = (): 'xs' | 'sm' | 'md' | 'lg' => {
  if (window.matchMedia('(max-width: 767px)').matches) return 'xs'
  if (window.matchMedia('(max-width: 1279px)').matches) return 'sm'
  if (window.matchMedia('(max-width: 1439px)').matches) return 'md'
  return 'lg'
}

export const getAppPlatform = () => {
  const match = navigator.userAgent.match(/advertising={"plattform":"(.+?)"}/)
  return match && match[1] ? match[1] : undefined
}

export const isMobile = (device: Device) => {
  return device.type === DeviceType.MOBILE || device.type === DeviceType.TABLET
}

/**
 * Detects the device based on the user agent headers.
 * @link https://nextjs.org/docs/app/api-reference/functions/user-agent
 *
 * @param headers
 *
 * @returns {Device} An instance of the Device class containing model, type, vendor, and OS information.
 */
export const device = (headers: any): Device => {
  if (!isServer()) {
    console.warn('Device detection only works serverside')
    return {
      model: 'Unknown',
      type: DeviceType.MOBILE,
      vendor: 'Unknown',
      os: 'Unknown',
    }
  }

  const { device, os } = require('next/server').userAgent({ headers })
  return {
    model: device.model,
    type: device.type,
    vendor: device.vendor,
    os: os.name,
  } as Device
}
